import React from "react";
import { useParams, Link, Navigate } from "react-router-dom";
import { findService } from "../data/services";
import { Phone, Check, ArrowRight } from "lucide-react";
import { SITE } from "../data/site";
import QuoteForm from "../components/QuoteForm";

export default function ServiceDetail() {
  const { slug } = useParams();
  const service = findService(slug);
  if (!service) return <Navigate to="/services" replace />;

  return (
    <div className="pt-20 bg-[#050505] min-h-screen" data-testid={`service-page-${slug}`}>
      {/* Hero */}
      <section className="relative h-[60vh] min-h-[480px] flex items-end overflow-hidden">
        <img src={service.hero} alt={service.name} className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-black/60 to-black/30" />
        <div className="relative max-w-7xl mx-auto px-6 pb-14 w-full">
          <div className="label-eyebrow mb-3">USA Limo Service</div>
          <h1 className="font-display text-5xl sm:text-6xl text-white tracking-tight max-w-3xl">{service.name}</h1>
          <p className="text-white/75 text-lg mt-4 max-w-2xl">{service.tagline}</p>
        </div>
      </section>

      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6 grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-7">
            <h2 className="font-display text-3xl text-white tracking-tight mb-5">{service.tagline}</h2>
            <p className="text-white/70 leading-relaxed text-[15px]">{service.short}</p>

            <h3 className="font-display text-2xl text-white mt-12 mb-6">What's included</h3>
            <ul className="space-y-3">
              {service.points.map((p) => (
                <li key={p} className="flex items-start gap-3 text-white/80">
                  <Check size={18} className="text-[#d4af6a] mt-0.5 flex-shrink-0" /> <span>{p}</span>
                </li>
              ))}
            </ul>

            <h3 className="font-display text-2xl text-white mt-12 mb-4">Who we serve</h3>
            <div className="flex flex-wrap gap-2">
              {service.audience.map((a) => (
                <span key={a} className="px-3 py-1.5 border border-white/15 text-white/70 text-xs tracking-wider uppercase">
                  {a}
                </span>
              ))}
            </div>

            <div className="mt-12 flex flex-wrap gap-3">
              <Link to="/book" className="btn-accent" data-testid="svc-book">Book Online <ArrowRight size={14} /></Link>
              <a href={`tel:${SITE.phonesTel.dispatch}`} className="btn-outline" data-testid="svc-call">
                <Phone size={14} /> Call {SITE.phones.dispatch}
              </a>
            </div>
          </div>
          <div className="lg:col-span-5">
            <QuoteForm
              serviceType={slug.includes("wedding") ? "wedding" : slug.includes("wine") ? "wine_tour" : slug.includes("corporate") ? "corporate" : slug.includes("armed") ? "armed_security" : slug.includes("coaches") ? "group" : "other"}
              title={`Request a ${service.name} Quote`}
              eyebrow="Tailored For You"
            />
          </div>
        </div>
      </section>
    </div>
  );
}
